import React from 'react';
import PersonIconHeader from '../Icons/PersonIconHeader';

const BtnLoginSignup = (props) => {
  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
  return (
    <a
      href={`${PUBLIC_URL}/login`}
      id="nav-login"
      className="flex items-center text-reliableBlack gap-1 pl-3 h-10"
      {...props}
    >
      <PersonIconHeader size={20} fill={`#4F4C4D`} />
      <p className="text-xs ml-1">
        <span className="font-semibold">Masuk</span> / Daftar
      </p>
    </a>
  );
};

export default BtnLoginSignup;
